var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 45.4 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M33.2 66.4V53.8c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.9-8.6 3.6M2.2 53.6h10.4L2.2 66.4h10.4M19.6 66.4V53.8h7.7M19.6 60.1h7.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZfp);
export default __webpack_public_path__ + "static/media/ZFP.8b8dbdaf5e479d703e08909ea7d7e75e.svg";
export { ForwardRef as ReactComponent };